import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

export default function BaseError({ errorMessage }) {
  BaseError.propTypes = {
    errorMessage: PropTypes.string,
  };
  return (
    <div className="error-message">
      <span className="error-message__hint error-message__hint_error">
        {errorMessage}
      </span>
    </div>
  );
}
